import { render, staticRenderFns } from "./sidebar-profile.vue?vue&type=template&id=babae002"
import script from "./sidebar-profile.vue?vue&type=script&lang=js"
export * from "./sidebar-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('babae002')) {
      api.createRecord('babae002', component.options)
    } else {
      api.reload('babae002', component.options)
    }
    module.hot.accept("./sidebar-profile.vue?vue&type=template&id=babae002", function () {
      api.rerender('babae002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/sidebar-profile.vue"
export default component.exports